import script from "./Forget.vue?vue&type=script&lang=ts&setup=true"
export * from "./Forget.vue?vue&type=script&lang=ts&setup=true"

import "./Forget.vue?vue&type=style&index=0&id=2621e29e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2621e29e"]])

export default __exports__